module.exports = __webpack_public_path__ + "static/img/iphone3.950fb07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/iphone3.png
// module id = d20T
// module chunks = 1